// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_featured-collection.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--featured-collection';
var CAROUSEL_CLASS = 'carousel--featured-collection';
var CAROUSEL_SECTION_SELECTOR = '.featured-collection';
var CAROUSEL_SECTION_CLASS = 'featured-collection';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));
  var desktopPrev = element.querySelector('.featured-collection__arrows--desktop .swiper-button-prev');
  var desktopNext = element.querySelector('.featured-collection__arrows--desktop .swiper-button-next');
  var mobilePrev = element.querySelector('.featured-collection__arrows--mobile .swiper-button-prev');
  var mobileNext = element.querySelector('.featured-collection__arrows--mobile .swiper-button-next');
  if (desktopPrev) desktopPrev.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-desktop-").concat(index));
  if (desktopNext) desktopNext.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-desktop-").concat(index));
  if (mobilePrev) mobilePrev.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-mobile-").concat(index));
  if (mobileNext) mobileNext.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-mobile-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
    slidesPerView: 2,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    a11y: false,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.

    breakpoints: {
      // when window width is >= 768px
      768: {
        slidesPerView: 4,
        spaceBetween: 24
      }
    },
    navigation: {
      nextEl: [desktopNext, mobileNext].filter(Boolean),
      prevEl: [desktopPrev, mobilePrev].filter(Boolean)
    },
    pagination: {
      el: element.querySelector('.swiper-pagination'),
      clickable: true
    }
  });
  swiper.slides.forEach(function (slide, index) {
    var slideLink = slide.querySelector('a');
    slideLink.addEventListener('focus', function () {
      swiper.slideTo(index);
    });
  });
});